import {call, put, select, takeLatest, takeLeading} from 'redux-saga/effects'

import {callIfNotExist, throwBadResponseError} from './helpers'
import {
  GET_FIT_PROFILE,
  GET_FIT_PROFILE_FAILURE,
  GET_FIT_PROFILE_SUCCESS,
  SET_FIT_PROFILE,
  getFitProfile,
  getFitProfileFailure,
  getFitProfilePending,
  getFitProfileSuccess,
  setFitProfileFailure,
  setFitProfilePending,
  setFitProfileSuccess,
} from '../actions/fitProfile'
import {setSizesSuccess} from '../actions/sizes'
import * as api from '../api/api'
import * as fitProfile from '../store/fitProfile'
import * as user from '../store/user'
import {failedToSaveFitProfile} from '../track/fit'

// Get Fit Profile
// ----------------------------------------------------------------------------

export const getFitProfileIfNotExist = callIfNotExist(
  fitProfile.isSuccess,
  getFitProfile,
  GET_FIT_PROFILE_FAILURE,
  GET_FIT_PROFILE_SUCCESS,
  'Could not get fit profile.',
)

export function* getFitProfileWorker() {
  try {
    yield put(getFitProfilePending())

    const userId = yield select(user.id)

    const response = yield call(api.getFitProfile, userId)

    const payload = api.onStatus({
      OK: ({json}) => json,
      404: () => undefined, // a fit profile don't exist for this user yet
      DEFAULT: throwBadResponseError,
    })(response)

    yield put(getFitProfileSuccess(payload))
  } catch (e) {
    console.error('Could not get fit profile.', e.message)
    yield put(getFitProfileFailure(e))
  }
}

export function* getFitProfileSaga() {
  yield takeLeading([GET_FIT_PROFILE], getFitProfileWorker)
}

// Set Fit Profile
// ----------------------------------------------------------------------------

export function* setFitProfileWorker({payload: {fitProfileData}}) {
  try {
    yield put(setFitProfilePending())

    const userId = yield select(user.id)
    const response = yield call(api.setFitProfile, userId, fitProfileData)

    const payload = api.onStatus({
      OK: ({json}) => json,
      400: ({json}) => {
        const errors = Object.values(json.data.errors)
        failedToSaveFitProfile({errors, fitProfileData})

        throwBadResponseError()
      },
      DEFAULT: throwBadResponseError,
    })(response)

    yield put(setFitProfileSuccess(payload.fitProfile))
    yield put(setSizesSuccess(payload.sizes))
  } catch (e) {
    console.error('Could not set fit profile.', e.message)
    yield put(setFitProfileFailure(e))
  }
}

export function* setFitProfileSaga() {
  yield takeLatest(SET_FIT_PROFILE, setFitProfileWorker)
}
